import { InfoObjectSchema as OriginalInfoObjectSchema } from '../processed/info-object'

/**
 * Info Object
 *
 * The object provides metadata about the API. The metadata MAY be used by the clients if needed,
 * and MAY be presented in editing or documentation generation tools for convenience.
 *
 * @see https://github.com/OAI/OpenAPI-Specification/blob/main/versions/3.1.1.md#info-object
 */
export const InfoObjectSchema = OriginalInfoObjectSchema
